import { computed } from "vue";
import { useServiceStore } from "../store/service";
import { useRouteUtils } from "../util/route";

export function useMenu() {
  const service = useServiceStore();
  const { tabSegments } = useRouteUtils();

  const activeMenuItem = computed(() => {
    if (service.ctx.gameProfile) {
      for (const menuSection of service.ctx.gameProfile?.menu) {
        for (const menuItem of menuSection.items) {
          if (menuItem.route == tabSegments.value[0]) {
            return menuItem;
          }
        }
      }
    }
    return undefined;
  });

  // TODO this is a pile of shit, we need to rewrite tab-routing to use vue-router dynamic interfaces
  const activeComponent = computed(() => {
    if (!activeMenuItem.value) return undefined;
    if (tabSegments.value.length > 1) {
      if (activeMenuItem.value?.subRoutes) {
        for (const subRoute of activeMenuItem.value?.subRoutes) {
          if (subRoute.route == tabSegments.value[1]) {
            return subRoute.component;
          }
        }
      }
      return undefined;
    }
    return activeMenuItem.value.component;
  });

  return { activeMenuItem, activeComponent };
}
